import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { ChangeATMPINStackRoutes, ChangeATMPINStackScreenProps } from './type';
import { ChangeATMPINWebZeroScreen } from './ChangeATMPINWebZero.screen';
import { ChangeATMPINNativeZeroScreen } from './ChangeATMPINNativeZero.screen';

export const ChangeATMPINMain: React.FC<ChangeATMPINStackScreenProps<ChangeATMPINStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, account, tab, record, func, onReturnData } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <ChangeATMPINNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        account={account}
        tab={tab}
        record={record}
        func={func}
        onReturnData={onReturnData}
      />
    );
  }

  return (
    <ChangeATMPINWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      account={account}
      tab={tab}
      record={record}
      func={func}
      onReturnData={onReturnData}
    />
  );
};
